export default __webpack_public_path__ + "static/logo-and-icons-light-52d0fb6a20a94373540776017b75f662daf0a7c1c8ba657b594107ccce691540.png";